import { GarnishmentStatus } from '@app/entities/enums/ptrab/garnishment-status.enum';

export class Garnishment {
  amount!: string;
  balance!: string;
  garnishor!: Garnishor;
  id!: string;
  date!: string;
  status!: GarnishmentStatus;
}

export interface Garnishor {
  entity_name: string;
  record: string;
  province: string;
  type: string;
  email: string;
  iban: string;
}

export interface GarnishAmountPayslip {
  next_garnishment: {
    amount: number;
  };
}
